<template>
    <!-- eslint-disable max-len -->
    <div
        class="patsnap-biz-header"
        :class="{
            [`patsnap-biz-header--${service.type}`]: true
        }"
    >
        <!-- 展示企业自定义  -->
        <a
            v-if="service.whiteLabel && service.customLogoVisible"
            :href="service.logoHref"
            class="patsnap-biz-header__logo patsnap-biz-header__custom-logo"
        >
            <img
                v-if="service.type === 'primary'"
                :src="service.customWhiteLogoUrl"
            >
            <img
                v-else
                :src="service.customLogoUrl"
            >
        </a>
        <!-- 分割线 -->
        <div
            v-if="logoVisible && service.whiteLabel && service.customLogoVisible"
            class="patsnap-biz-header__divider"
        />
        <!-- logo -->
        <a
            v-if="logoVisible"
            class="patsnap-biz-header__logo"
            :href="service.logoHref"
        >
            <slot
                name="logo"
                :service="service"
            />
        </a>
        <!-- 分割线 -->
        <div
            v-if="service.title && (logoVisible || (service.whiteLabel && service.customLogoVisible))"
            class="patsnap-biz-header__divider"
        />
        <!--  title -->
        <div
            v-if="service.title"
            class="patsnap-biz-header__title"
        >
            <slot
                v-if="getSlotName(service.title)"
                :name="getSlotName(service.title)"
            />
            <span v-else>
                {{ service.title }}
            </span>
        </div>
        <ul
            class="patsnap-biz-header__widgets left"
            :style="{
                marginLeft: service.checkLogoOrTitleVisible($scopedSlots.logo) ? '32px': '0'
            }"
        >
            <template v-for="(item, index) in service.left">
                <div
                    v-if="getSlotName(item)"
                    :key="`pt-header-left-widget-${index}`"
                    class="patsnap-biz-header__widget-item"
                >
                    <slot :name="getSlotName(item)" />
                </div>
                <div
                    v-else-if="!item.menu"
                    :key="`pt-header-left-widget-${index}`"
                    class="patsnap-biz-header__widget-item"
                >
                    <PtHeaderWidget
                        v-bind="{
                            target: item.href ? (item.target || '_blank') : undefined
                        }"
                        :href="item.href"
                        :icon="item.icon"
                        :label="item.label"
                        :post-icon="item.postIcon"
                        :aria-label="item.tooltip"
                        data-balloon-pos="down"
                    />
                </div>
                <PtHeaderDropdown
                    v-else
                    :key="`pt-header-left-widget-${index}`"
                    :trigger="item.trigger === 'hover' ? 'hover' : 'click'"
                    align="left"
                    class="patsnap-biz-header__widget-item"
                >
                    <template #reference>
                        <PtHeaderWidget
                            :icon="item.icon"
                            :label="item.label"
                            :post-icon="item.postIcon"
                            :aria-label="item.tooltip"
                            data-balloon-pos="down"
                        />
                    </template>
                    <template #popper>
                        <slot
                            v-if="getSlotName(item.menu)"
                            :name="getSlotName(item.menu)"
                        />
                        <PtList
                            v-else
                            :class="{
                                [item.classname || '']: true
                            }"
                            :items="item.menu"
                        />
                    </template>
                </PtHeaderDropdown>
            </template>
        </ul>
        <div class="patsnap-biz-header__spacer">
            <slot />
        </div>
        <ul
            v-if="service.syncing"
            class="patsnap-biz-header__widgets patsnap-biz-header__widgets-skeleton"
        >
            <li />
            <li />
            <li />
        </ul>
        <ul
            v-else
            class="patsnap-biz-header__widgets right"
        >
            <template v-for="(item, index) in service.right">
                <div
                    v-if="getSlotName(item)"
                    :key="`pt-header-right-widget-${index}`"
                    class="patsnap-biz-header__widget-item"
                >
                    <slot :name="getSlotName(item)" />
                </div>
                <div
                    v-else-if="!item.menu"
                    :key="`pt-header-right-widget-${index}`"
                    class="patsnap-biz-header__widget-item"
                >
                    <PtHeaderWidget
                        v-bind="{
                            target: item.href ? (item.target || '_blank') : undefined
                        }"
                        :href="item.href"
                        :icon="item.icon"
                        :label="item.label"
                        :post-icon="item.postIcon"
                        :aria-label="item.tooltip"
                        data-balloon-pos="down"
                    />
                </div>
                <PtHeaderDropdown
                    v-else
                    :key="`pt-header-right-widget-${index}`"
                    :trigger="item.trigger === 'hover' ? 'hover' : 'click'"
                    :is-show-popover-immediate="item.showPopper"
                    class="patsnap-biz-header__widget-item"
                >
                    <template #reference>
                        <PtHeaderWidget
                            :icon="item.icon"
                            :label="item.label"
                            :post-icon="item.postIcon"
                            :aria-label="item.tooltip"
                            data-balloon-pos="down"
                        />
                    </template>
                    <template #popper>
                        <slot
                            v-if="getSlotName(item.menu)"
                            :name="getSlotName(item.menu)"
                        />
                        <PtList
                            v-else
                            :class="{
                                [item.classname || '']: true,
                                'column-layout': service.helpCenterGuiderVisible && service.helpCenterGuiderConfig && item.hasGuider
                            }"
                            :items="item.menu"
                        >
                            <template
                                v-if="service.helpCenterGuiderVisible && service.helpCenterGuiderConfig && item.hasGuider"
                                #prefix
                            >
                                <HelpCenterGuider
                                    :guider-config="service.helpCenterGuiderConfig"
                                />
                            </template>
                        </PtList>
                    </template>
                </PtHeaderDropdown>
            </template>
            <div
                v-if="service.canUseNotifications"
                class="patsnap-biz-header__widget-item"
            >
                <Notifications />
            </div>
            <PtHeaderDropdown
                v-if="service.visibleProducts"
                class="patsnap-biz-header__widget-item"
                trigger="hover"
            >
                <template #reference>
                    <div class="patsnap-biz-header__widget-item__reference">
                        <PtHeaderWidget
                            icon="Products"
                        />
                        <div
                            v-if="service.hasNewProducts"
                            class="patsnap-biz-header__widget-item__new-tip"
                        >
                            {{ $t('PtHeader.new') }}
                        </div>
                    </div>
                </template>
                <template #popper>
                    <PtProductsShell
                        ref="products"
                        :home-btn-visible="!!(service.account && service.account.canAccessHomePage)"
                    />
                </template>
            </PtHeaderDropdown>
            <PtUserCenter
                ref="userCenter"
                :service="service.userCenterService"
                class="patsnap-biz-header__widget-item"
            >
                <template #header="{ trigger }">
                    <Tenants
                        :value="service.tenants"
                        :trigger="trigger"
                    />
                    <UserBanner
                        :account="service.account"
                    >
                        <template
                            v-for="name in tranformSlotNames"
                            #[name]
                        >
                            <slot :name="name" />
                        </template>
                    </UserBanner>
                </template>
                <template #language="{ trigger }">
                    <Languages
                        ref="language"
                        :value="service.locales"
                        :trigger="trigger"
                        :arrow="trigger ? 'right': 'down'"
                        @change="handleLanguageChange"
                    />
                </template>
                <template
                    v-for="(value, name) in $slots"
                    #[name]
                >
                    <slot
                        v-if="name !== 'header' && name !== 'language' "
                        :name="name"
                    />
                </template>
            </PtUserCenter>
        </ul>
    </div>
</template>

<script>
import PtUserCenter from '@patsnap-biz/user-center';
import PtList from '@patsnap-biz/list';
import { HeaderService, getSlotName } from '@patsnap-utils/biz';
import PtHeaderDropdown from './HeaderDropdown';
import PtProductsShell from './ProductsShell';
import PtHeaderWidget from './HeaderWidget';
import Languages from './Languages';
import UserBanner from './UserBanner.vue';
import HelpCenterGuider from './HelpCenterGuider';
import Tenants from './Tenants';
import Notifications from './Notifications';
import cn from '../locales/cn';
import en from '../locales/en';
import jp from '../locales/jp';
import tw from '../locales/tw';

function removeChildren(parent) {
    while (parent.lastChild) {
        parent.removeChild(parent.lastChild);
    }
    return parent;
}

export default {
    name: 'PtHeader',
    i18n: {
        fallbackLocale: 'cn',
        messages: {
            cn, en, jp, tw,
        },
    },
    components: {
        PtList,
        PtProductsShell,
        PtUserCenter,
        PtHeaderDropdown,
        PtHeaderWidget,
        Languages,
        UserBanner,
        HelpCenterGuider,
        Tenants,
        Notifications,
    },
    provide() {
        return {
            service: this.service,
        };
    },
    props: {
        /**
         * 为 header 提供数据
         */
        service: {
            type: Object,
            default() {
                return new HeaderService();
            },
        },
    },
    computed: {
        logoVisible() {
            return this.service.logoVisible && (this.$slots.logo || this.$scopedSlots.logo);
        },
        tranformSlotNames() {
            const slotNames = [
                'default',
                'logo',
                getSlotName(this.service.title),
                ...this.service.right.map((item) => getSlotName(item)),
                ...this.service.left.map((item) => getSlotName(item)),
            ].filter((item) => item);
            const names = Object.keys(this.$slots).filter((name) => !slotNames.includes(name));
            return names;
        },
    },
    mounted() {
        this.mountToTarget();
    },
    methods: {
        getSlotName,
        handleLanguageChange(language) {
            this.service.setLocale(language);
        },
        mountToTarget() {
            const { mountElement } = this.service;
            let target;
            if (mountElement instanceof HTMLElement) {
                target = mountElement;
            } else if (typeof mountElement === 'string') {
                target = document.querySelector(mountElement);
            }
            if (target) {
                removeChildren(target).appendChild(this.$el);
            }
        },
    },
};
</script>
